import { fetchConToken } from '../helpers/fetch';
import {types} from '../types/types';


export const startItemAddNewAction = ( item ) => ({
    type: types.carritoAddItem,
    payload: item

});

export const carritoDeleteItemAction = ( item ) => ({
    type: types.carritoDeleteItemGetLoaded,
    payload: item
});

export const carritoStartLoadingAction = () => {
    return async( dispatch ) => {

        try {

            const resp = await fetchConToken('articuloservicios');
            const body = await resp.json();

            const articulosServicios = body.asrtservicios;

            //console.log(equiposComp);
            dispatch( carritoLoadedAction( articulosServicios ) );
            
        } catch (error) {
            console.log(error);
        }
    }
}

const carritoLoadedAction = ( artServ ) => ({
    type: types.carritoGetLoaded,
    payload: artServ
});